module.exports = __webpack_public_path__ + "static/img/yeswecan0007.14d632c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0007.png
// module id = 582
// module chunks = 1